module.exports = __webpack_public_path__ + "img/stressmonster101-99ab8144-4d19-42e2-489f-08d95b7e528f.png";